// Por debajo de este límite no se muestran elipsis (igual que bootstrap-vue).
const ELLIPSIS_THRESHOLD = 3

export const getNumberOfPages = (totalRows, perPage) => {
  const rows = Math.max(Number(totalRows) || 0, 0)
  const size = Math.max(Number(perPage) || 1, 1)
  return Math.max(Math.ceil(rows / size), 1)
}

export const clampPage = (page, numberOfPages) => {
  const value = Number(page) || 1
  return Math.min(Math.max(value, 1), numberOfPages)
}

/**
 * Botones de página visibles, con el mismo algoritmo que <b-pagination>:
 * cerca del inicio "1 2 3 4 …", al medio "… 4 5 6 …", cerca del final "… 7 8 9 10".
 *
 * @returns {{ pages: number[], showFirstDots: boolean, showLastDots: boolean, numberOfPages: number }}
 */
export const buildPaginationPages = ({ currentPage, numberOfPages, limit = 5, hideEllipsis = false }) => {
  const max = Math.max(Number(limit) || 5, 1)
  const current = clampPage(currentPage, numberOfPages)
  let showFirstDots = false
  let showLastDots = false
  let numberOfLinks = max
  let startNumber = 1

  if (numberOfPages <= max) {
    numberOfLinks = numberOfPages
  } else if (current < max - 1 && max > ELLIPSIS_THRESHOLD) {
    if (!hideEllipsis) {
      showLastDots = true
      numberOfLinks = max - 1
    }
  } else if (numberOfPages - current + 2 < max && max > ELLIPSIS_THRESHOLD) {
    if (!hideEllipsis) {
      showFirstDots = true
      numberOfLinks = max - 1
    }
    startNumber = numberOfPages - numberOfLinks + 1
  } else {
    if (max > ELLIPSIS_THRESHOLD && !hideEllipsis) {
      numberOfLinks = max - 2
      showFirstDots = true
      showLastDots = true
    }
    startNumber = current - Math.floor(numberOfLinks / 2)
  }

  startNumber = Math.min(Math.max(startNumber, 1), numberOfPages - numberOfLinks + 1)
  const pages = Array.from({ length: numberOfLinks }, (_, index) => startNumber + index)

  return { pages, showFirstDots, showLastDots, numberOfPages }
}
